import Hero from "../components/home/Hero";
import EditorialMarquee from "../components/home/Marquee";
import Properties from "../components/home/Properties";
import Steps from "../components/home/Steps";
import SellBuy from "../components/home/SellBuy";
import Cities from "../components/home/Cities";
import Testimonials from "../components/home/Testimonials";
import AlertBanner from "../components/home/AlertBanner";

export default function Home() {
  return (
    <>
      <Hero />
      <EditorialMarquee />
      <Properties />
      <Testimonials />
      <AlertBanner />
      <Steps />
      <SellBuy />
      <Cities />
    </>
  );
}
